export const NEW_TAB_TARGET = '_blank'
export const SAME_TAB_TARGET = '_self'
export const LOGIN_TO_WIX_URL = 'https://users.wix.com/signin?'
export const USER_FILES_BASE_DOMAIN = 'filesusr.com'
